import React, {useState} from "react";
import {useEffect} from "react";
import {useHistory} from "react-router-dom";

const ManageServices = () => {
  const [services, setServices] = useState([]);
  useEffect(() => {
    const url = "https://hidden-everglades-07947.herokuapp.com/services/";
    fetch(url)
      .then(res => res.json())
      .then(data => setServices(data));
  }, []);

  let history = useHistory();

  const handleDelete = id => {
    const url = `https://hidden-everglades-07947.herokuapp.com/services/${id}`;

    fetch(url, {
      method: "DELETE"
    })
      .then(res => res.json())
      .then(data => {
        if (data.deletedCount) {
          alert("deleted");
          const remaining = services.filter(service => service._id !== id);
          setServices(remaining);
          history.push("/home#services");
        }
      });
  };

  return (
    <div>
      <h2>This is manage Services</h2>
      {services.map(service => (
        <div key={service._id}>
          <h3>{service.name}</h3>
          <button onClick={() => handleDelete(service._id)}>delete</button>
        </div>
      ))}
    </div>
  );
};

export default ManageServices;
